import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import ButtonBlue from "../../components/Button/ButtonBlue";
import NewTask from "./NewAssignment";
import { useDispatch, useSelector } from "react-redux";
import Modal from "../../components/Modal/ModelNewPopup";
import { getTeachingCourses } from "../../redux/actions/teachingCourses";
import noProfile from "../../common/images-new/no-profile-pic.png";
import axios from "axios";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import { serverUrl } from "../../components/Helpers/Config";
import Swal from "sweetalert2";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import DoneOutlinedIcon from "@mui/icons-material/DoneOutlined";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import DPEditor from "../../components/Editor/DPEditor";
import RichContent from "../../components/Editor/RichContent";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { toast } from "react-toastify";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";

import { format } from "date-fns";
import { parse, parseISO } from "date-fns";
// import Select from "react-select";
import {
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Tooltip,
} from "@mui/material";
// import GET_TEACHING_PREVIEW from "../../redux/reducers/teaching";
// import TeachingPreview from "./TeachingPreview";
import {
  BgBlue,
  ButtonCommonTopNew,
  SideBarActiveDiv,
  SideBarActiveDivButtonNew,
  SideBarNormalDivButtonNew,
  TextGray,
} from "../Theme";
import CardTeachingPreview from "../../components/Card/CardTeachingPreview";
import { Progress } from "react-sweet-progress";
import { addAttribute, tokenAuthorize } from "../../components/Helpers/Common";
import moment from "moment";
import Button from "../../components/Button/Button";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ButtonCommon from "../../components/Button/ButtonCommon";
import { BiLeftArrowAlt, BiSolidHourglass } from "react-icons/bi";
import TaskReorderModal from "../../components/Modal/TaskReorderModal";
import { getUserNavigationConfrimPopup } from "../../redux/actions/commonAction";

const tutor = [
  {
    tutor_id: 4848,
    tutor_name: "tester",
  },
  {
    tutor_id: 2648,
    tutor_name: "Test User 1",
  },
  {
    tutor_id: 2649,
    tutor_name: "Test User 2",
  },
];

export default function NewAssignmentList(props) {
  const id = props.match.params.id;
  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();
  const isDefaultTheme = useSelector((state) => state.auth.isDefaultTheme);
  const userTheme = useSelector((state) => state.auth.theme);
  const courses = useSelector((state) => state.teachingCourses.courses);
  const [title, setTitle] = useState("");
  const [groupId, setGroupId] = useState(-1);
  const [created, setCreated] = useState("");
  const [dueDate, setDueDate] = useState(null);
  const [desc, setDesc] = useState("");
  const [tasks, setTasks] = useState([]);
  const [preview, setPreview] = useState([]);
  const [course, setCourse] = useState("");
  const [count, setCount] = useState(0);
  const [dateIcon, setDateIcon] = useState("");
  const [tutorId, setTutorId] = useState("");
  const [tutors, setTutors] = useState([]);
  const [isDisable, setisDisable] = useState(true);
  const [currentTask, setCurrentTask] = useState(null);
  const [selectedIndex, setselectedIndex] = useState(0);
  const [selectedIndexPreview, setSelectedPreviewIndex] = useState(0);
  const [currentTaskPreview, setCurrentTaskPreview] = useState(null);
  const [isAddtask, setIsAddTask] = useState(false);
  const [taskName, setTaskName] = useState("");
  const buttonRef = useRef(null);
  const inputAddTaskRef = useRef(null);
  const [isReorderOpen, setIsReorderOpen] = useState(false);
  const [isValueChanged, setValueChanged] = useState(false);
  const userNavigatingConfrimPopup = useSelector(
    (state) => state.commonData.userNavigatingConfrimPopup || false
  );

  const handleDate = (e) => {
    const icon = new Date(e).getDate();
    setDateIcon(icon);
    setDueDate(e);
  };

  useEffect(() => {
    setTutorId("");
    setTutordetail(null);
  }, [groupId]);

  const handleReorder = (tasks, index) => {
    setTasks(tasks);
    setselectedIndex(index);
    dispatch(getUserNavigationConfrimPopup(true));
    setValueChanged(true);
  };

  //Tutor
  useEffect(() => {
    if (groupId !== -1) {
      axios
        .get(serverUrl.TeachingCourse + `/${groupId}`)
        .then((res) => {
          if (res.status === 200) {
            let data = res.data;
            setisDisable(false);
            setTutors(data);
          }
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
        });
    } else {
      setisDisable(true);
    }
  }, [groupId]);

  useEffect(() => {
    dispatch(getTeachingCourses());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      axios
        .get(serverUrl.Teaching + `/${id}`)
        .then((resp) => {
          if (resp.status === 200) {
            const data = resp.data;
            setGroupId(
              data.groups && data.groups.length > 0 ? data.groups[0].id : -1
            );
            setTitle(data.list_name);
            setTasks(data.tasks);
            changeCurrentTask(data.tasks);
            // setTasks(reorderdata);
            setDesc(data.list_desc);
            let dueDate = new Date(data.list_due);
            const tzoffset = dueDate.getTimezoneOffset() * 60000;
            const tzDueDate = new Date(dueDate.getTime() - tzoffset)
              .toISOString()
              .substr(0, 10);
            let created = new Date(data.list_created);
            setDateIcon(dueDate.getDate());
            setCreated(
              created.getFullYear() +
              "-" +
              (created.getMonth() + 1) +
              "-" +
              created.getDate()
            );
            const dateObj = parseISO(data.list_due);
            const parsed = format(dateObj, "dd-MM-yyyy");
            setDueDate(parsed);
            setCount(
              tasks.length > 0 ? Math.floor(Math.random() * tasks.length) : 0
            );
            setTutorId(data?.main_tutor_id);
            dispatch(getUserNavigationConfrimPopup(false));
            setValueChanged(false);
          }
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
        });
    }
  }, [id]);

  const notifyError = (messages) => {
    tasks.map((r) => (r.is_deleted = false));
    setTasks(tasks);
    let errorText = "";
    if (messages && messages.length > 0) {
      errorText = messages.join("<br/>");
    } else {
      errorText = "Something went wrong!";
    }

    Swal.fire({
      heightAuto: false,
      icon: "error",
      title: "Error",
      html: errorText,
    });
  };

  const handleRequest = async () => {
    tasks.map((i, ind) => (i.task_order = ind + 1));
    setTasks(tasks);
    let list_due = null;
    if (dueDate) {
      const parsedDate = parse(dueDate, "dd-MM-yyyy", new Date());
      list_due = format(parsedDate, "yyyy-MM-dd");
    }
    if (id) {
      axios
        .put(serverUrl.Teaching + `/${id}`, {
          list_name: title,
          list_due: list_due,
          list_desc: desc,
          group_id: groupId,
          main_tutor_id: tutorId == "" ? null : parseInt(tutorId),
          tasks,
        })
        .then((resp) => {
          axios
            .get(serverUrl.Teaching + `/${id}`)
            .then((resp) => {
              if (resp.status === 200) {
                const data = resp.data;
                setGroupId(
                  data.groups && data.groups.length > 0 ? data.groups[0].id : -1
                );
                setTitle(data.list_name);
                setTasks(data.tasks);
                // changeCurrentTask(data.tasks);
                // setTasks(reorderdata);
                setDesc(data.list_desc);
                let dueDate = new Date(data.list_due);
                const tzoffset = dueDate.getTimezoneOffset() * 60000;
                const tzDueDate = new Date(dueDate.getTime() - tzoffset)
                  .toISOString()
                  .substr(0, 10);
                let created = new Date(data.list_created);
                setDateIcon(dueDate.getDate());
                setCreated(
                  created.getFullYear() +
                  "-" +
                  (created.getMonth() + 1) +
                  "-" +
                  created.getDate()
                );
                const dateObj = parseISO(data.list_due);
                const parsed = format(dateObj, "dd-MM-yyyy");
                setDueDate(parsed);
                setCount(
                  tasks.length > 0
                    ? Math.floor(Math.random() * tasks.length)
                    : 0
                );
                setTutorId(data?.main_tutor_id);
                dispatch(getUserNavigationConfrimPopup(false));
                setValueChanged(false);
              }
            })
            .catch((error) => {
              tokenAuthorize(error?.response?.status);
            });
          if (resp.status === 200) {
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Task list has been updated",
              icon: "success",
              showCancelButton: false,
              showDenyButton: true,
              confirmButtonText: "To Tutor Dashboard",
              denyButtonText: "Continue Editing",
              confirmButtonColor: "#3085d6",
              denyButtonColor: "#c1c1c1",
            }).then((result) => {
              if (result.isConfirmed) {
                history.push("/teaching");
              } else if (result.isDenied) {
                Swal.close();
              }
            });
          } else {
            notifyError();
          }
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
          notifyError(error.response.data);
        });
    } else {
      var thisIsObject = {};
      let data = [];
      let filterdata = tasks.filter((i) => i.is_deleted == false);
      filterdata.map(
        (i) => (
          (thisIsObject = i),
          delete thisIsObject["is_deleted"],
          (i = thisIsObject),
          data.push(thisIsObject),
          (thisIsObject = {})
        )
      );
      axios
        .post(serverUrl.Teaching, {
          group_id: groupId,
          list_name: title,
          list_due: list_due,
          list_desc: desc,
          tasks: data,
          main_tutor_id: tutorId == "" ? null : parseInt(tutorId),
        })
        .then((resp) => {
          if (resp.status === 200) {
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Task list has been created",
              icon: "success",
              showCancelButton: false,
              showDenyButton: true,
              confirmButtonText: "To Tutor Dashboard",
              denyButtonText: "Continue Editing",
              confirmButtonColor: "#3085d6",
              denyButtonColor: "#c1c1c1",
            }).then((result) => {
              if (result.isConfirmed) {
                history.push("/teaching");
              } else if (result.isDenied) {
                history.push("/teaching/edit/" + resp.data.id[0]?.list_id);
              }
            });
          } else {
            notifyError();
          }
        })
        .catch((error) => {
          tokenAuthorize(error?.response?.status);
          notifyError(error.response.data);
        });
    }
  };

  const handleAddTask = () => {
    setTasks([
      ...tasks,
      {
        task_name: "",
        task_detail: "",
        task_response: 0,
        is_deleted: false,
        task_order: tasks?.length > 0 ? tasks.length + 1 : 0,
      },
    ]);
  };

  const formatModernDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short", // Jan, Feb, Mar, etc.
      day: "numeric", // 1, 2, 3...
    });
  };

  const setTaskData = (itemIndex, inputType, updatedData) => {
    setValueChanged(true);
    dispatch(getUserNavigationConfrimPopup(true));
    setTasks((prevState) => {
      let updatedTasks = [...prevState];

      switch (inputType) {
        case 0:
          updatedTasks[itemIndex].task_detail = updatedData;
          break;
        case 1:
          updatedTasks[itemIndex].task_name = updatedData;
          break;
        case 2:
          updatedTasks[itemIndex].task_response = updatedData;
          break;
        case 3:
          updatedTasks[itemIndex].is_deleted = true;
          changeCurrentTask(updatedTasks);
          break;
        case 4:
          if (updatedData == "up" && itemIndex == 0) {
            var temp = updatedTasks[itemIndex];
            updatedTasks[itemIndex] = updatedTasks[updatedTasks?.length - 1];
            updatedTasks[updatedTasks?.length - 1] = temp;
          }
          if (updatedData == "down" && itemIndex == updatedTasks?.length - 1) {
            var temp = updatedTasks[0];
            updatedTasks[0] = updatedTasks[updatedTasks?.length - 1];
            updatedTasks[updatedTasks?.length - 1] = temp;
          }
          if (updatedData == "up" && itemIndex > 0) {
            var temp = updatedTasks[itemIndex];
            updatedTasks[itemIndex] = updatedTasks[itemIndex - 1];
            updatedTasks[itemIndex - 1] = temp;
          }
          if (
            updatedData == "down" &&
            itemIndex >= 0 &&
            itemIndex != updatedTasks?.length - 1
          ) {
            var temp = updatedTasks[itemIndex];
            updatedTasks[itemIndex] = updatedTasks[itemIndex + 1];
            updatedTasks[itemIndex + 1] = temp;
          }
          updatedTasks?.map((i, ind) => (i.task_order = ind + 1));
          break;
        default:
          break;
      }
      if (inputType !== 3) {
        setCurrentTask(updatedTasks[itemIndex]);
      }
      return updatedTasks;
    });
  };

  const handleDragEnd = (param) => {
    const srcIdx = param.source.index;
    const desIdx = param.destination?.index;
    // if (desIdx) {
    tasks.splice(desIdx, 0, tasks.splice(srcIdx, 1)[0]);
    // }
    tasks.map((i, ind) => (i.task_order = ind + 1));
    setTasks(tasks);
  };

  const [tutorDetail, setTutordetail] = useState(null);

  const handlePreview = () => {
    setTutordetail(
      tutors.filter((data) => data.tutor_id.toString() == tutorId)?.[0]
    );
    setCourse(courses.filter((r) => r.group_id == groupId)[0]?.group_name);
    setPreview(true);
    setSelectedPreviewIndex(selectedIndex);
    setCurrentTaskPreview(currentTask);
  };

  const goBack = () => {
    setPreview(false);
  };

  const handleCancel = () => {
    if (userNavigatingConfrimPopup) {
      Swal.fire({
        heightAuto: false,
        title: "Warning",
        text: "Are you sure to leave this page?",
        icon: "warning",
        showCancelButton: false,
        showDenyButton: true,
        confirmButtonText: "Confirm",
        denyButtonText: "Cancel",
        confirmButtonColor: "#3085d6",
        denyButtonColor: "#c1c1c1",
      }).then((result) => {
        if (result.isConfirmed) {
          history.push("/teaching");
          dispatch(getUserNavigationConfrimPopup(false));
        }
      });
    } else {
      history.push("/teaching");
    }
  };

  const handleInputAddShowcaseBlur = (e) => {
    if (e?.nativeEvent?.relatedTarget?.id === buttonRef?.current?.id) {
      handleAddTaskFocus();
      return;
    }
    setIsAddTask(false);
  };

  useEffect(() => {
    handleAddTaskFocus();
  }, [isAddtask]);

  useEffect(() => {
    dispatch(getUserNavigationConfrimPopup(false));
  }, []);

  const handleAddTaskFocus = () => {
    if (isAddtask && inputAddTaskRef.current) {
      inputAddTaskRef.current.focus(); // focus after entering edit mode
    }
  };

  const handleCreateTask = () => {
    if (taskName?.trim() == "" || !taskName?.trim()) {
      handleAddTaskFocus();
      toast.error("Please enter the task name");
    } else {
      handleNewTask(taskName);
      setTaskName("");
      setIsAddTask(false);
    }
  };

  const handleNewTask = (taskname) => {
    let taskList = tasks;
    taskList = [
      ...taskList,
      {
        task_name: taskName,
        task_detail: "",
        task_response: 0,
        is_deleted: false,
        task_order: tasks?.length > 0 ? tasks.length + 1 : 0,
      },
    ];
    if (!currentTask) {
      changeCurrentTask(taskList);
    }
    setTasks([
      ...tasks,
      {
        task_name: taskName,
        task_detail: "",
        task_response: 0,
        is_deleted: false,
        task_order: tasks?.length > 0 ? tasks.length + 1 : 0,
      },
    ]);
    setValueChanged(true);
    dispatch(getUserNavigationConfrimPopup(true));
  };

  const changeCurrentTask = (taskList) => {
    if (taskList.filter((data) => data.is_deleted == false).length == 0) {
      setCurrentTask(null);
    } else {
      const firstActiveTask = taskList.find(
        (task) => task?.is_deleted === false
      );
      setCurrentTask(firstActiveTask !== undefined ? firstActiveTask : null);
    }

    if (taskList.length == 0) {
      setselectedIndex(-1);
    } else {
      const firstActiveIndex = taskList.findIndex(
        (task) => task?.is_deleted === false
      );
      setselectedIndex(firstActiveIndex);
    }
  };

  return (
    <div>
      {preview == false && (
        <>
          <Modal
            isOpen={isReorderOpen}
            onClose={() => setIsReorderOpen(false)}
            header="Reorder Task"
          >
            <TaskReorderModal
              tasks={tasks}
              onSave={handleReorder}
              selectedIndex={selectedIndex}
              onClose={() => {
                setIsReorderOpen(false);
              }}
            />
          </Modal>
          <div className="flex flex-col pt-2 md:pt-6 ">
            <div className="px-3 md:px-5">
              <div className="flex mt-2 text-sm mb-4 justify-between items-center">
                {/* <div className="flex items-center">
                  <ButtonCommonTopNew
                    className={`rounded-lg px-5 py-2 flex items-center w-max cursor-pointer`}
                    onClick={handleCancel}
                  >
                    <BiLeftArrowAlt className="w-5 h-5" />
                    <h1 className="text-xs lg:text-sm">Back</h1>
                  </ButtonCommonTopNew>
                </div> */}
                <div
                  className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                  onClick={handleCancel}
                >
                  <KeyboardBackspaceIcon
                    style={{ fontSize: "28px" }}
                    className=" primaryIcon"
                  />
                  <h1 className="text-lg blueColor font-semibold">Back</h1>
                </div>
                <div className="flex items-center gap-3">
                  <ButtonCommon
                    className={"px-6 py-2"}
                    title="Preview"
                    onClick={handlePreview}
                  />
                  <ButtonCommon
                    className={"px-6 py-2"}
                    title="Save"
                    onClick={handleRequest}
                  />
                </div>
              </div>
              <div className="flex items-center gap-3 flex-wrap w-full">
                <div className="flex items-center gap-3">
                  <span className="text-black font-semibold text-sm">
                    Name:{" "}
                  </span>
                  <input
                    type="text"
                    className="px-2 py-1.5 border rounded border-gray-300 text-sm w-44"
                    placeholder="DP task list name"
                    value={title}
                    onChange={(e) => {
                      setTitle(e.target.value);
                      setValueChanged(true);
                      dispatch(getUserNavigationConfrimPopup(true));
                    }}
                  />
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-black font-semibold text-sm">
                    Due on:{" "}
                  </span>
                  {/* <input
                    type="date"
                    className="px-2 py-1 border border-gray-300 rounded w-44"
                    value={"2025-09-20"}
                    min={moment(new Date()).format("yyyy-MM-DD")}
                    onChange={(date) => {
                      handleDate(date);
                      setValueChanged(true);
                      dispatch(getUserNavigationConfrimPopup(true));
                    }}
                  /> */}
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <KeyboardDatePicker
                      format="dd/MM/yyyy"
                      placeholder="dd/mm/yyyy"
                      value={
                        dueDate
                          ? parse(dueDate, "dd-MM-yyyy", new Date())
                          : null
                      }
                      onChange={(date) => {
                        handleDate(date ? format(date, "dd-MM-yyyy") : "");
                        dispatch(getUserNavigationConfrimPopup(true));
                      }}
                      minDate={new Date()}
                      style={{ width: "176px" }} // same as w-44
                      InputProps={{
                        readOnly: true,
                        disableUnderline: true, // removes default MUI underline
                        style: {
                          backgroundColor: "#fff", // filled background
                          border: "1px solid #ccc", // custom border
                          borderRadius: "4px",
                          padding: "8px 10px",
                          paddingRight: "2px",
                          height: "36px",
                          boxSizing: "border-box",
                        },
                      }}
                      error={false} // 🔹 disables red error border
                      helperText=""
                      InputLabelProps={{
                        shrink: true, // keeps label above
                        style: { fontSize: "0.875rem" },
                      }}
                    />
                  </MuiPickersUtilsProvider>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-black font-semibold text-sm">
                    Assigned for:{" "}
                  </span>
                  <Select
                    labelId="course-group-select-label"
                    value={groupId}
                    className="w-44"
                    style={{ height: "35px" }}
                    onChange={(e) => {
                      setGroupId(e.target.value);
                      setValueChanged(true);
                      dispatch(getUserNavigationConfrimPopup(true));
                    }}
                    displayEmpty
                    MenuProps={{
                      disableScrollLock: true,
                    }}
                  >
                    <MenuItem value={-1} disabled>
                      Course Group
                    </MenuItem>
                    {courses
                      .filter((data) => data.is_archived == false)
                      .sort((a, b) =>
                        String(a.group_name).localeCompare(String(b.group_name))
                      )
                      .map((option, idx) => (
                        <MenuItem key={idx} value={option.group_id}>
                          {option.group_name}
                        </MenuItem>
                      ))}
                  </Select>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-black font-semibold text-sm">
                    Tutor:{" "}
                  </span>
                  <Select
                    labelId="tutor-select-label"
                    style={{ height: "35px" }}
                    className="w-44"
                    value={tutorId}
                    onChange={(e) => {
                      setTutorId(parseInt(e.target.value));
                      setValueChanged(true);
                      dispatch(getUserNavigationConfrimPopup(true));
                    }}
                    MenuProps={{
                      disableScrollLock: true,
                    }}
                  >
                    <MenuItem value="" disabled>
                      Select Tutor
                    </MenuItem>
                    {tutors
                      .sort((a, b) =>
                        String(a.fullname).localeCompare(String(b.fullname))
                      )
                      .map((option, idx) => (
                        <MenuItem key={idx} value={option.tutor_id}>
                          {option.fullname}
                        </MenuItem>
                      ))}
                  </Select>
                </div>
              </div>
              <p className="font-bold mt-4 mb-4">Description: </p>
              <div className="grid pb-5">
                <DPEditor
                  valueChanges={() => {
                    setValueChanged(true);
                    dispatch(getUserNavigationConfrimPopup(true));
                  }}
                  content={desc}
                  setContent={setDesc}
                  height={300}
                />
              </div>
              {/* <div className="flex justify-end my-6">
              <ButtonCommonTopNew
                className="px-4 py-2 text-sm rounded-lg cursor-pointer"
                onClick={handleAddTask}
              >
                + Add More Task
              </ButtonCommonTopNew>
            </div> */}
            </div>
            <div className=" lg:pl-5 flex w-full h-full border-top-f1 flex-col lg:flex-row">
              <div className="w-72 border-right-f1 pr-5 py-4 hidden lg:block">
                <SideBarActiveDiv className="text-xl font-bold blackColor flex items-center justify-between gap-5  py-1">
                  {isAddtask ? (
                    <>
                      <input
                        className="bg-white border rounded-md text-black bg-transparent text-sm placeholder-gray-500 focus:outline-none pl-3 h-9 w-full border-gray-500"
                        type="text"
                        ref={inputAddTaskRef}
                        autoFocus
                        placeholder="Add task"
                        value={taskName}
                        onChange={(e) => setTaskName(e.target.value)}
                        onBlurCapture={(e) => handleInputAddShowcaseBlur(e)}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            handleCreateTask();
                          }
                        }}
                      />
                    </>
                  ) : (
                    <>Tasks</>
                  )}
                  {!isAddtask ? (
                    <div className="flex items-center gap-3">
                      {tasks.filter((data) => data.is_deleted == false).length >
                        1 && (
                          <Tooltip title={"Reorder task"} placement="top" arrow>
                            <ButtonCommonTopNew
                              className="flex items-center border w-8 h-8 justify-center rounded-lg cursor-pointer"
                              onClick={() => {
                                setIsReorderOpen(true);
                              }}
                            >
                              <SwapVertIcon
                                style={{ fontSize: "22px" }}
                                className="cursor-pointer"
                              />
                            </ButtonCommonTopNew>
                          </Tooltip>
                        )}
                      <Tooltip title={"New task"} placement="top" arrow>
                        <ButtonCommonTopNew
                          className="flex items-center border w-8 h-8 justify-center rounded-lg cursor-pointer"
                          onClick={() => {
                            setIsAddTask(true);
                            setTaskName("");
                          }}
                        >
                          <AddOutlinedIcon className="cursor-pointer primaryIcon" />
                        </ButtonCommonTopNew>
                      </Tooltip>
                    </div>
                  ) : (
                    <Tooltip title={"Add task"} placement="top" arrow>
                      <ButtonCommonTopNew
                        className="flex items-center border p-1 rounded-lg cursor-pointer"
                        ref={buttonRef}
                        id="blur"
                        tabIndex={0}
                        onClick={() => {
                          handleCreateTask();
                        }}
                      >
                        <DoneOutlinedIcon className="cursor-pointer primaryIcon" />
                      </ButtonCommonTopNew>
                    </Tooltip>
                  )}
                </SideBarActiveDiv>
                <div className="flex flex-col flex-1 mt-1 ">
                  {tasks.map((list, index) => {
                    if (list?.is_deleted) return null; // skip deleted but keep index reference

                    return selectedIndex === index ? (
                      <SideBarActiveDivButtonNew
                        key={index}
                        type="button"
                        className="text-md flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium"
                        onClick={() => {
                          setCurrentTask(list);
                          setselectedIndex(index);
                        }}
                      >
                        {list.task_name}
                      </SideBarActiveDivButtonNew>
                    ) : (
                      <SideBarNormalDivButtonNew
                        key={index}
                        type="button"
                        className="text-md flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium"
                        onClick={() => {
                          setCurrentTask(list);
                          setselectedIndex(index);
                        }}
                      >
                        {list.task_name}
                      </SideBarNormalDivButtonNew>
                    );
                  })}
                </div>
              </div>
              <div className=" py-5 ml-1 px-5 cardBackgroundColor flex items-center justify-between lg:hidden gap-2">
                <div className="flex items-center gap-2">
                  {isAddtask ? (
                    <input
                      className="bg-white border rounded-md text-black bg-transparent text-sm placeholder-gray-500 focus:outline-none pl-3 h-9 w-full border-gray-500"
                      type="text"
                      autoFocus
                      ref={inputAddTaskRef}
                      placeholder="Add task"
                      value={taskName}
                      onChange={(e) => setTaskName(e.target.value)}
                      onBlurCapture={(e) => handleInputAddShowcaseBlur(e)}
                    />
                  ) : (
                    <>
                      <span className="text-sm blackColor">Tasks:</span>
                      <Select
                        labelId="task-select-label"
                        className="w-44"
                        style={{ height: "35px" }}
                        value={selectedIndex}
                        onChange={(e) => {
                          const selected = tasks.find(
                            (t, index) => index === e.target.value
                          );
                          if (selected) {
                            setCurrentTask(selected);
                            setselectedIndex(e.target.value);
                          }
                        }}
                        MenuProps={{
                          disableScrollLock: true,
                        }}
                      >
                        {tasks.map((task, index) => {
                          if (task?.is_deleted) return null;

                          return (
                            <MenuItem key={index} value={index}>
                              {task.task_name}
                            </MenuItem>
                          );
                        })}
                      </Select>
                    </>
                  )}
                </div>
                {!isAddtask ? (
                  <div className="flex items-center gap-3">
                    {tasks.filter((data) => data.is_deleted == false).length >
                      1 && (
                        <Tooltip title={"Reorder task"} placement="top" arrow>
                          <ButtonCommonTopNew
                            className="flex items-center border w-8 h-8 justify-center rounded-lg cursor-pointer"
                            onClick={() => {
                              setIsReorderOpen(true);
                            }}
                          >
                            <SwapVertIcon
                              style={{ fontSize: "22px" }}
                              className="cursor-pointer"
                            />
                          </ButtonCommonTopNew>
                        </Tooltip>
                      )}
                    <Tooltip title={"New task"} placement="top" arrow>
                      <ButtonCommonTopNew
                        className="flex items-center border w-8 h-8 justify-center rounded-lg cursor-pointer"
                        onClick={() => {
                          setIsAddTask(true);
                          setTaskName("");
                        }}
                      >
                        <AddOutlinedIcon className="cursor-pointer primaryIcon" />
                      </ButtonCommonTopNew>
                    </Tooltip>
                  </div>
                ) : (
                  <Tooltip title={"Add task"} placement="top" arrow>
                    <ButtonCommonTopNew
                      className="flex items-center border p-1 rounded-lg cursor-pointer"
                      ref={buttonRef}
                      id="blur"
                      tabIndex={0}
                      onClick={() => {
                        handleCreateTask();
                      }}
                    >
                      <DoneOutlinedIcon className="cursor-pointer primaryIcon" />
                    </ButtonCommonTopNew>
                  </Tooltip>
                )}
              </div>
              <div className="flex-1 backGroundColor p-5 border20pxbottomright">
                {currentTask && (
                  <NewTask
                    key={selectedIndex}
                    item={currentTask}
                    index={selectedIndex}
                    setTaskData={setTaskData}
                  />
                )}
                {!currentTask && (
                  <span className="flex h-full items-center justify-center w-full text-md font-semibold blackColor">
                    Please create a task
                  </span>
                )}
              </div>
            </div>
            {/* <div className="space-y-10">
            {tasks &&
              tasks.map(
                (task, idx) =>
                  task?.is_deleted == false && (
                    <NewTask
                      key={idx}
                      item={task}
                      index={idx}
                      setTaskData={setTaskData}
                    />
                  )
              )}
          </div> */}
          </div>
        </>
      )}
      {preview == true && (
        <>
          <div className="text-center bg-white-300 px-3 pt-3 text-2xl font-bold">
            PREVIEW MODE
          </div>
          <div className="md:pt-6 pt-2 ">
            <div className="px-3 md:px-5">
              <div className="flex items-center ">
                <div
                  className={`rounded-lg p-0 flex gap-1 items-center w-max cursor-pointer`}
                  onClick={goBack}
                >
                  <KeyboardBackspaceIcon
                    style={{ fontSize: "28px" }}
                    className=" primaryIcon"
                  />
                  <h1 className="text-lg blueColor font-semibold">Back</h1>
                </div>
                <p className=" text-3xl font-bold break-words flex-1 text-center">
                  {title}
                </p>
              </div>
              <div className="flex items-center justify-between  gap-5 mt-5 flex-wrap">
                {tutorDetail?.fullname !== "" && (
                  <div className="flex itesm-center gap-5 items-center">
                    <div className="flex items-center gap-2">
                      {tutorDetail?.fullname !== "" && (
                        <>
                          <span>
                            <img
                              src={
                                tutorDetail?.photo
                                  ? tutorDetail?.photo
                                  : noProfile
                              }
                              className="w-12 h-12 rounded-full object-cover "
                            />
                          </span>
                          <div className="flex flex-col">
                            {course && (
                              <span className="text-lg font-semibold blackColor">
                                {course}
                              </span>
                            )}
                            {tutorDetail?.fullname && (
                              <span className="text-md blackColor flex gap-1.5">
                                {tutorDetail?.fullname}
                              </span>
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                )}
                <div className="flex items-center gap-5 flex-wrap">
                  <div className="text-md blackColor flex items-center gap-1">
                    <span className="lightColor">Task completed:</span>{" "}
                    {tasks.length > 0
                      ? Math.floor((count / tasks.length) * 100)
                      : 0}
                    %
                  </div>
                  <div>
                    <span className="text-md blackColor flex items-center gap-1">
                      <span className="lightColor">Due on:</span>{" "}
                      {dueDate ? formatModernDate(dueDate) : ""}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex flex-col px-5 md:px-0 whitespace-nowrap">
                <RichContent content={addAttribute(desc)} />
              </div>
            </div>
            <div className="flex w-full h-full border-top-f1 flex-col lg:flex-row">
              <div className="w-64 border-right-f1 pl-4 pr-5 py-4 hidden lg:block">
                <SideBarActiveDiv className="font-14px font-semibold  py-1">
                  Tasks
                </SideBarActiveDiv>
                <div className="flex flex-col flex-1 mt-1 border-left-f1 ml-1 pl-2">
                  {tasks.map((list, index) => {
                    if (list?.is_deleted) return null;

                    return selectedIndexPreview === index ? (
                      <SideBarActiveDivButtonNew
                        type="button"
                        className="font-14px flex items-center justify-between text-left whitespace-normal py-1 my-1 pl-2 pr-2 w-full cursor-pointer font-medium"
                        key={index}
                        onClick={() => {
                          setCurrentTaskPreview(list);
                          setSelectedPreviewIndex(index);
                        }}
                      >
                        {list.task_name}{" "}
                        <CheckCircleIcon
                          // style={{
                          //   color:
                          //     isDefaultTheme == false
                          //       ? userTheme?.color2
                          //       : "#F4A300",
                          //   fontSize: "18px",
                          // }}
                          className=" flex-shrink-0 secondaryIcon"
                        />
                      </SideBarActiveDivButtonNew>
                    ) : (
                      <SideBarNormalDivButtonNew
                        type="button"
                        className="font-14px flex items-center justify-between text-left whitespace-normal lightColor pl-2 pr-2 my-1 pb-1 pt-1 w-full cursor-pointer font-medium"
                        key={index}
                        onClick={() => {
                          setCurrentTaskPreview(list);
                          setSelectedPreviewIndex(index);
                        }}
                      >
                        {list.task_name}
                        <CheckCircleIcon
                          // style={{
                          //   color:
                          //     isDefaultTheme == false
                          //       ? userTheme?.color2
                          //       : "#F4A300",
                          //   fontSize: "18px",
                          // }}
                          className="flex-shrink-0 secondaryIcon"
                        />
                      </SideBarNormalDivButtonNew>
                    );
                  })}
                </div>
              </div>
              <div className=" py-5 ml-1 px-5 cardBackgroundColor flex items-center lg:hidden gap-2">
                <span className="text-sm blackColor">Tasks:</span>
                <Select
                  labelId="task-select-label"
                  className="w-44"
                  style={{ height: "35px" }}
                  value={selectedIndexPreview}
                  onChange={(e) => {
                    const selected = tasks.find(
                      (t, index) => index === e.target.value
                    );
                    if (selected) {
                      setCurrentTaskPreview(selected);
                      setSelectedPreviewIndex(e.target.value);
                    }
                  }}
                  MenuProps={{
                    disableScrollLock: true,
                  }}
                >
                  {tasks.map((task, index) => {
                    if (task?.is_deleted) return null;

                    return (
                      <MenuItem key={index} value={index}>
                        {task.task_name}
                      </MenuItem>
                    );
                  })}
                </Select>
              </div>
              <div className="flex-1 backGroundColor p-5 border20pxbottomright">
                {currentTaskPreview && (
                  <CardTeachingPreview
                    key={currentTaskPreview.task_id}
                    data={{
                      id: currentTaskPreview.task_id,
                      name: currentTaskPreview.task_name,
                      // completed: list.response_status,
                      action: currentTaskPreview.task_response
                        ? currentTaskPreview.task_response
                        : 0,
                      detail: currentTaskPreview.task_detail || "",
                    }}
                  // onPostUpdate={refreshData}
                  />
                )}
              </div>
            </div>
            {/* {(tasks.length > 0 &&
              tasks.map(
                (list, index) =>
                  list?.is_deleted == false && (
                    <CardTeachingPreview
                      key={index}
                      data={{
                        id: list.task_id,
                        name: list.task_name,
                        // completed: list.response_status,
                        action: list.task_response ? list.task_response : 0,
                        detail: list.task_detail || "",
                      }}
                      // onPostUpdate={refreshData}
                    />
                  )
              )) ||
              null} */}
          </div>
        </>
      )}
    </div>
  );
}
